// Phase A.2b shim: implementation moved to @p81-common/shell-core-js.
// Named exports: CURRENT_SESSION, init (as initSessionStorage), getCurrentSession,
// setCurrentSession, removeSession, getActivateSubscriptionDismissedOn,
// setActivateSubscriptionDismissedOn, getCurtainSpogSrc, setCurtainSpogSrc,
// getSaasApiRequestSent, setSaasApiRequestSent, getSWSSOToken, setSWSSOToken,
// getSWSSODomain, setSWSSODomain, getRememberedIdp, setRememberedIdp, removeRememberedIdp,
// getRedirectedToIdp, setRedirectedToIdp, removeRedirectedToIdp, getAndRemoveAuth0SignInState,
// setAuth0SignInState, getAndRemoveShouldRememberIdp, setShouldRememberIdp, removeShouldRememberIdp,
// getLogoutReason, setLogoutReason, getAuth0SSOData, configureSessionStorage.
// Default export { init } preserved for App.tsx backward compat.
import { initSessionStorage } from "@p81-common/shell-core-js";
export * from "@p81-common/shell-core-js";

// Preserve the default export shape `{ init }` that App.tsx uses via `localStorage.init()`.
export default { init: initSessionStorage };
